import { FieldValues } from 'react-hook-form';

import { ETripEvent } from 'detailsv2/structure';

import { PendingPage } from '../useDefaultValues/types';
import { useTripEventDefaultValuesQuery } from './useTripEventDefaultValuesQuery';

type Props = {
  eventType: ETripEvent;
  page: PendingPage;
  onSuccess?: (defaultValues: FieldValues) => void;
};

export function useTripEventDefaultsLoader({ eventType, page, onSuccess }: Props) {
  const { isFetching, isLoading, data } = useTripEventDefaultValuesQuery(page, eventType, {
    onSuccess: async (res) => {
      const defaultValues = res?.data?.defaultValues;
      if (!defaultValues) return;
      onSuccess?.(defaultValues);
    },
  });

  return {
    isFetching,
    isLoading,
    savedDefaultValues: data?.data?.defaultValues,
  };
}
